<footer #footerElement class="footer px-2 py-2">
  <div class="container-fluid d-flex flex-wrap justify-content-between align-items-center px-4 py-3">

    <!-- Logo + derechos -->
    <div class="d-flex align-items-center gap-2">
      <img src="assets/img/brand/logo_jamar_gray.svg" width="86px" alt="Logo Jamar" />
      <small class="text-muted">
        © {{ DATE | date:'yyyy' }} {{ APP_NAME }}. Todos los derechos reservados.
      </small>
    </div>

    <!-- Enlaces -->
    <ul class="nav">
      <li class="nav-item">
        <a href="https://www.jamar.com/pages/nosotros" target="_blank" class="nav-link px-2 text-muted">
          Sobre nosotros
        </a>
      </li>
      <li class="nav-item">
        <a href="mailto:merlin@jamar.com?subject=Soporte técnico - Plataforma" class="nav-link px-2 text-primary">
          Soporte técnico
        </a>
      </li>
    </ul>

  </div>
</footer>
